(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-cotizador"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Precios netos (sin IVA) de los servicios de la flota compartida (software, conectividad y
    // estaciones de carga): no son productos de la tienda. Los vehículos sí salen del catálogo.
    var P = { dock: 962167, cabinet: 3802667, cabBattery: 530917, dockAdapter: 95833, scooterCable: 9583, bikeCable: 11500, setup: 5833333, gateway: 4166667, fee: 16667, sim: 13333, agent: 3333 };
    var RATE = 0.02, IVA = 0.19, OPEX_MANT = 30000, OPEX_REP = 15000, INS = 15000;
    var TIERS = [{ min: 1, max: 5, d: 0 }, { min: 6, max: 10, d: 0.1 }, { min: 11, max: 20, d: 0.15 }, { min: 21, max: Infinity, d: 0.2 }];
    var MIN_FLOTA = 20;
    var fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var ceil = Math.ceil;
    var fechaLarga = function (d) { return d.toLocaleDateString('es-CL', { day: '2-digit', month: 'long', year: 'numeric' }); };
    function tierFor(n) { return TIERS.find(function (t) { return n >= t.min && n <= t.max; }) || null; }
    function bucketOf(km) { return km <= 40 ? 'Hasta 40 km' : km <= 80 ? '40 a 80 km' : 'Más de 80 km'; }
    var BUCKETS = ['Hasta 40 km', '40 a 80 km', 'Más de 80 km'];

    function init(root) {
      if (root.dataset.listo) return;
      root.dataset.listo = '1';
      var uid = root.dataset.emCot;
      var CAT, CFG;
      try { CAT = JSON.parse(root.querySelector('[data-cot-cat]').textContent); } catch (e) { CAT = []; }
      try { CFG = JSON.parse(root.querySelector('[data-cot-cfg]').textContent); } catch (e) { CFG = {}; }
      CAT.forEach(function (m) { m.bucket = bucketOf(m.range); });
      var $ = function (k) { return root.querySelector('[data-cot="' + k + '"]'); };
      var N = function (k) { return uid + '-' + k; };
      root.querySelector('aside').id = 'Cotizador-' + uid + '-ticket';

      var S = {
        mode: 'b2b2c', pay: 'compra', term: 36, ins: false,
        type: CAT.some(function (c) { return c.type === 'scooter'; }) ? 'scooter' : 'bicicleta',
        buckets: new Set(), powers: new Set(),
        qty: {}, mant: false, cab: false, dock: false, adp: false, cabBat: 0, gateway: false
      };
      var today = new Date();
      var quoteNo = 'COT-' + today.toISOString().slice(2, 10).replace(/-/g, '') + '-' + String(Math.floor(Math.random() * 900) + 100);
      var dateStr = fechaLarga(today);
      var validUntil = fechaLarga(new Date(today.getTime() + 15 * 864e5));
      var resumen = '';

      function stepper(id, val) {
        return '<span class="cq-stepper"><button type="button" data-act="dec" data-id="' + id + '" aria-label="Quitar uno">−</button><input type="number" inputmode="numeric" min="0" max="2000" value="' + val + '" data-act="set" data-id="' + id + '" aria-label="Cantidad"><button type="button" data-act="inc" data-id="' + id + '" aria-label="Agregar uno">+</button></span>';
      }
      function totalUnitsC() { return Object.keys(S.qty).reduce(function (a, k) { return a + S.qty[k]; }, 0); }
      function unitPrice(m, t) { return Math.min(m.list * (1 - (t ? t.d : 0)), m.price); }

      /* ---------- Paneles de configuración ---------- */
      function typeSeg() {
        var opt = function (k, label) {
          var ms = CAT.filter(function (c) { return c.type === k; });
          if (!ms.length) return '';
          var brands = Array.from(new Set(ms.map(function (c) { return c.brand; }))).join(' y ');
          var pw = ms.map(function (c) { return c.power; }).filter(Boolean);
          var rango = pw.length ? ' · de ' + Math.min.apply(null, pw) + ' a ' + Math.max.apply(null, pw) + ' W' : '';
          return '<label><input type="radio" name="' + N('type') + '" value="' + k + '"' + (S.type === k ? ' checked' : '') + '><span class="cq-opt"><b>' + label + '</b><small>' + ms.length + ' modelos ' + esc(brands) + rango + '</small></span></label>';
        };
        return '<div class="cq-seg" role="radiogroup" aria-label="Tipo de vehículo" style="margin-bottom:18px">' + opt('scooter', 'Scooter') + opt('bicicleta', 'Bicicleta') + '</div>';
      }
      function unitsOf(type) { return CAT.reduce(function (a, m) { return a + (m.type === type ? S.qty[m.id] || 0 : 0); }, 0); }
      function modelCard(m, t) {
        var q = S.qty[m.id] || 0;
        var eff = unitPrice(m, t);
        var st = m.status === 'stock' ? '<span class="cq-tag cq-tag--stock">En stock</span>'
          : m.status === 'preventa' ? '<span class="cq-tag cq-tag--preventa">Preventa</span>'
          : m.status === 'cotizar' ? '<span class="cq-tag cq-tag--cotizar">A pedido</span>'
          : '<span class="cq-tag cq-tag--agotado">Agotado</span>';
        var spec = [(m.type === 'scooter' ? 'Scooter' : 'Bicicleta') + (m.fold ? ' plegable' : '')];
        if (m.power) spec.push(m.power + ' W');
        if (m.range) spec.push('hasta ' + m.range + ' km');
        return '<article class="cq-model' + (q ? ' is-sel' : '') + '">' +
          (m.img ? '<img class="cq-thumb" src="' + m.img + '" alt="" width="76" height="76" loading="lazy">' : '<span class="cq-thumb"></span>') +
          '<div><h4><a href="' + m.url + '" target="_blank" rel="noopener">' + esc(m.brand) + ' ' + esc(m.name) + '</a></h4><p class="cq-spec">' + spec.join(' · ') + '</p>' + st + '</div>' +
          '<div class="cq-mprice"><div class="cq-pr">' + (eff < m.list ? '<s class="num">' + fmt(m.list) + '</s>' : '') + '<b class="num">' + fmt(eff) + '</b><br>IVA incluido</div>' + stepper(m.id, q) + '</div>' +
          '</article>';
      }
      function renderFleet() {
        var body = $('fleetBody');
        var flota = S.mode === 'b2b2s';
        $('fleetTitle').textContent = flota ? 'Arma la flota' : 'Elige los vehículos';
        var units = totalUnitsC();
        var t = tierFor(units);
        var deTipo = CAT.filter(function (c) { return c.type === S.type; });
        var bucketsAll = BUCKETS.filter(function (b) { return deTipo.some(function (c) { return c.bucket === b; }); });
        var powersAll = Array.from(new Set(deTipo.map(function (c) { return c.power; }).filter(Boolean))).sort(function (a, b) { return a - b; });
        var chip = function (grp, val, label, checked) { return '<label class="cq-chip"><input type="checkbox" name="' + N(grp) + '" value="' + esc(val) + '"' + (checked ? ' checked' : '') + '><span>' + esc(label) + '</span></label>'; };
        var list = deTipo.filter(function (c) { return (!S.buckets.size || S.buckets.has(c.bucket)) && (!S.powers.size || S.powers.has(c.power)); });
        var nextTier = TIERS.find(function (x) { return x.min > units; });
        var nota;
        if (units === 0) nota = (flota ? 'La flota compartida parte en ' + MIN_FLOTA + ' unidades, sumando scooters y bicicletas. ' : '') + 'El descuento se calcula sobre el total de unidades de la cotización y se aplica al precio de lista. Desde 6 unidades hay descuento.';
        else if (nextTier) nota = 'Llevas ' + units + ' unidad' + (units > 1 ? 'es' : '') + ' ' + (t.d ? 'con ' + Math.round(t.d * 100) + '% de descuento' : 'a precio de tienda') + '. Con ' + nextTier.min + ' unidades ' + (t.d ? 'sube a ' : 'obtienes ') + Math.round(nextTier.d * 100) + '% de descuento.';
        else nota = 'Llevas ' + units + ' unidades con el descuento máximo de 20%.';
        var html = typeSeg() +
          '<div class="cq-ladder" aria-label="Escala de descuento por volumen">' + TIERS.map(function (x) {
            return '<div class="' + (t === x ? 'is-on' : '') + '"><b>' + (x.d ? Math.round(x.d * 100) + '%' : 'Lista') + '</b>' + (x.max === Infinity ? '21 o más unidades' : x.min === 1 ? 'Hasta ' + x.max + ' unidades' : x.min + ' a ' + x.max + ' unidades') + '</div>';
          }).join('') + '</div>' +
          '<p class="cq-ladder-note">' + nota + '</p>' +
          (flota && units > 0 && units < MIN_FLOTA ? '<div class="cq-alert" role="alert" style="margin-bottom:16px">La implementación mínima es de ' + MIN_FLOTA + ' unidades. Esta flota tiene ' + units + '.</div>' : '') +
          '<div class="cq-filters">' +
            (bucketsAll.length > 1 ? '<div class="cq-frow"><span class="cq-lbl">Autonomía</span>' + bucketsAll.map(function (b) { return chip('bucket', b, b, S.buckets.has(b)); }).join('') + '</div>' : '') +
            (powersAll.length > 1 ? '<div class="cq-frow"><span class="cq-lbl">Potencia</span>' + powersAll.map(function (p) { return chip('power', p, p + ' W', S.powers.has(p)); }).join('') + '</div>' : '') +
          '</div>' +
          (list.length ? '<div class="cq-models">' + list.map(function (m) { return modelCard(m, t); }).join('') + '</div>' : '<div class="cq-empty">Ningún modelo cumple esos filtros. Quita alguno para ver más opciones.</div>');
        if (flota) {
          var docks = units ? ceil(units / 4) * 4 : 0, cabs = docks ? ceil(docks / 20) : 0;
          var row = function (id, checked, name, sub, extra) {
            return '<div class="cq-row cq-row--col"><label><input type="checkbox" data-opt="' + id + '"' + (checked ? ' checked' : '') + '><span>' + name + '<small>' + sub + '</small></span></label>' + (extra || '') + '</div>';
          };
          html += '<p class="cq-subhead">Estaciones de carga <small>Opcional</small></p>' +
            '<p class="cq-hint" style="margin-top:0">Los vehículos ya incluyen batería y cargador, así que las estaciones de carga son una solución adicional que no es obligatorio comprar.</p>' +
            '<div class="cq-info">La compra de estos dispositivos no incluye montaje, instalación, tramitación de permisos ni obras civiles.</div>' +
            '<div class="cq-opts">' +
              row('cab', S.cab, 'Estación de carga (gabinete de control)', '1 gabinete cada 20 docks' + (units ? ' · ' + cabs + ' unidad' + (cabs === 1 ? '' : 'es') : ''),
                S.cab ? '<div class="cq-sub"><label for="' + N('cabBat') + '">Baterías de respaldo por estación</label><select id="' + N('cabBat') + '" data-opt="cabBat">' + [0, 1, 2, 3, 4].map(function (n) { return '<option value="' + n + '"' + (S.cabBat === n ? ' selected' : '') + '>' + n + '</option>'; }).join('') + '</select></div>' : '') +
              row('dock', S.dock, 'Dock Station', '1 por vehículo, en múltiplos de 4' + (units ? ' · ' + docks + ' docks' : '')) +
              row('adp', S.adp, 'Adaptadores para los vehículos', '1 por vehículo' + (units ? ' · ' + units + ' adaptadores' : '')) +
            '</div>';
        }
        body.innerHTML = html;
      }
      function renderExtras() {
        var b2s = S.mode === 'b2b2s';
        $('swStep').hidden = !b2s;
        if (b2s) {
          $('swBody').innerHTML = '<div class="cq-opts" style="margin-top:0">' +
            '<div class="cq-row"><div>Implementación de la licencia<small>Pago único para el setup del sistema. Incluye app de usuario, app de operación y panel de administración.</small></div><span class="cq-pv num">' + fmt(P.setup) + '</span></div>' +
            '<div class="cq-row"><label><input type="checkbox" data-opt="gateway"' + (S.gateway ? ' checked' : '') + '><span>Integración de la pasarela de pago<small>Opcional · para el cobro a usuarios finales. Pago único.</small></span></label><span class="cq-pv num">' + fmt(P.gateway) + '</span></div>' +
            '</div><p class="cq-hint">Valores netos, más IVA.</p>';
        }
        $('opexBody').innerHTML = '<div class="cq-opts" style="margin-top:0">' +
          (b2s ? '<div class="cq-row"><div>Fee mensual por vehículo<small>Conectividad, SIM y Super Agent</small></div><span class="cq-pv num">' + fmt(P.fee + P.sim + P.agent) + ' al mes</span></div>' : '') +
          (b2s ? '<div class="cq-row"><div>Contrato de mantención y repuestos<small>Incluido · por vehículo al mes</small></div><span class="cq-pv num">' + fmt(OPEX_MANT + OPEX_REP) + ' al mes</span></div>'
               : '<div class="cq-row"><label><input type="checkbox" data-opt="mant"' + (S.mant ? ' checked' : '') + '><span>Contrato de mantención y repuestos<small>Opcional · por vehículo al mes</small></span></label><span class="cq-pv num">' + fmt(OPEX_MANT + OPEX_REP) + ' al mes</span></div>') +
          '<div class="cq-row"><label><input type="checkbox" data-opt="ins"' + (S.ins ? ' checked' : '') + '><span>Seguro<small>Opcional · por vehículo al mes</small></span></label><span class="cq-pv num">' + fmt(INS) + ' al mes</span></div>' +
          '</div><p class="cq-hint">Valores netos, más IVA.</p>';
      }
      function numberSteps() {
        var k = 0;
        root.querySelectorAll('.cq-step').forEach(function (s) { if (!s.hidden) { k++; s.querySelector('.cq-n').textContent = k; } });
      }

      /* ---------- Modelo de la cotización ---------- */
      function buildQuote() {
        var L = [], R = [], veh = 0, notes = [];
        veh = totalUnitsC();
        var t = tierFor(veh);
        CAT.forEach(function (m) { var q = S.qty[m.id] || 0; if (q > 0) L.push({ g: 'Vehículos', label: m.brand + ' ' + m.name, qty: q, unit: unitPrice(m, t) / (1 + IVA) }); });
        if (t && t.d) notes.push({ k: 'info', t: 'Descuento por volumen de ' + Math.round(t.d * 100) + '% sobre precio de lista (' + veh + ' unidades).' });
        if (S.mode === 'b2b2s') {
          var sc = unitsOf('scooter'), bk = unitsOf('bicicleta');
          var docks = veh ? ceil(veh / 4) * 4 : 0, cabs = docks ? ceil(docks / 20) : 0;
          if (veh && (S.cab || S.dock || S.adp)) {
            var g = 'Estaciones de carga (opcional)';
            if (S.cab) { L.push({ g: g, label: 'Estación de carga (gabinete de control)', qty: cabs, unit: P.cabinet }); if (S.cabBat) L.push({ g: g, label: 'Batería de respaldo de estación', qty: S.cabBat * cabs, unit: P.cabBattery }); }
            if (S.dock) L.push({ g: g, label: 'Dock Station', qty: docks, unit: P.dock });
            if (S.adp) { if (sc) L.push({ g: g, label: 'Adaptador para scooter', qty: sc, unit: P.dockAdapter + P.scooterCable }); if (bk) L.push({ g: g, label: 'Adaptador para bicicleta', qty: bk, unit: P.dockAdapter + P.bikeCable }); }
            notes.push({ k: 'info', t: 'La compra de las estaciones de carga no incluye montaje, instalación, tramitación de permisos ni obras civiles.' });
          }
          if (veh) {
            L.push({ g: 'Software', label: 'Implementación de la licencia (pago único, setup del sistema)', qty: 1, unit: P.setup });
            if (S.gateway) L.push({ g: 'Software', label: 'Integración de la pasarela de pago', qty: 1, unit: P.gateway });
            R.push({ label: 'Conectividad, SIM y Super Agent', qty: veh, unit: P.fee + P.sim + P.agent });
          }
          if (veh > 0 && veh < MIN_FLOTA) notes.push({ k: 'warn', t: 'La flota está bajo el mínimo de implementación de ' + MIN_FLOTA + ' unidades.' });
        }
        if (veh) {
          if (S.mode === 'b2b2s' || S.mant) R.push({ label: 'Mantención', qty: veh, unit: OPEX_MANT }, { label: 'Fee de repuestos', qty: veh, unit: OPEX_REP });
          if (S.ins) R.push({ label: 'Seguro (opcional)', qty: veh, unit: INS });
        }
        var sum = function (a) { return Math.round(a.reduce(function (s, l) { return s + l.qty * l.unit; }, 0)); };
        return { L: L, R: R, veh: veh, initNet: sum(L), recNet: sum(R), notes: notes };
      }
      var withIva = function (n) { return n + Math.round(n * IVA); };
      function scenarios(q, n) {
        var f = RATE / (1 - Math.pow(1 + RATE, -n));
        var compra = { init: withIva(q.initNet), month: withIva(q.recNet) };
        compra.total = compra.init + compra.month * n;
        var cuotaNet = Math.round(q.initNet * f);
        var leasing = { init: 0, cuota: withIva(cuotaNet), month: withIva(cuotaNet + q.recNet) };
        leasing.total = leasing.month * n;
        return { compra: compra, leasing: leasing };
      }

      /* ---------- Ticket ---------- */
      function renderTerm(show, label) {
        var box = $('termBox'); box.hidden = !show; if (!show) return;
        if (box.dataset.k === label) return;
        box.dataset.k = label;
        box.innerHTML = '<p class="cq-label">' + label + '</p><div class="cq-seg" role="radiogroup" aria-label="' + label + '">' +
          [24, 36].map(function (m) { return '<label><input type="radio" name="' + N('term') + '" value="' + m + '"' + (S.term === m ? ' checked' : '') + '><span class="cq-opt"><b>' + m + ' meses</b></span></label>'; }).join('') + '</div>';
      }
      function renderTicket() {
        var q = buildQuote(), n = S.term, hasRec = q.recNet > 0, leas = S.pay === 'leasing';
        renderTerm(leas || hasRec, leas ? (hasRec ? 'Plazo del leasing y del OPEX' : 'Plazo del leasing') : 'Plazo del OPEX');
        var el = $('ticket');
        var client = $('fClient').value.trim(), contact = $('fContact').value.trim();
        var head = '<div class="cq-printhead">' + (CFG.logo ? '<img src="' + CFG.logo + '" alt="E-Mobility" width="150">' : '') + esc(CFG.empresa || '') + '</div>' +
          '<div class="cq-tk-head"><div><h3>Cotización</h3><p class="num">' + quoteNo + ' · ' + dateStr + '</p></div><p style="text-align:right">Válida hasta<br><b class="num">' + validUntil + '</b></p></div>' +
          '<div class="cq-perf"></div>' +
          '<div class="cq-client"><div><b>Empresa:</b> ' + (client ? esc(client) : '—') + (contact ? ' · ' + esc(contact) : '') + '</div><div><b>Solución:</b> ' + (S.mode === 'b2b2c' ? 'Vehículo individual' : 'Flota compartida') + '</div></div>' +
          '<div class="cq-perf"></div>';
        if (!q.veh) {
          el.innerHTML = head + '<div class="cq-empty">Agrega al menos un vehículo para ver el detalle y los totales.</div>';
          $('mTotal').textContent = '$0';
          resumen = '';
          return;
        }
        var sc = scenarios(q, n);
        var cur = leas ? sc.leasing : sc.compra;
        var showTerm = leas || hasRec;
        var line = function (l) { return '<tr><td>' + esc(l.label) + '</td><td class="num">' + l.qty + '</td><td class="num">' + fmt(l.unit) + '</td><td class="num">' + fmt(l.qty * l.unit) + '</td></tr>'; };
        var rows = '', lastG = '';
        q.L.forEach(function (l) { if (l.g !== lastG) { rows += '<tr class="cq-grp"><td colspan="4">' + esc(l.g) + '</td></tr>'; lastG = l.g; } rows += line(l); });
        var ivaI = Math.round(q.initNet * IVA), ivaR = Math.round(q.recNet * IVA), recG = q.recNet + ivaR;
        var best = sc.compra.total <= sc.leasing.total ? 'compra' : 'leasing';
        var sum;
        if (!leas) {
          sum = '<div class="cq-l">Compra: pago inicial</div><div class="cq-v num">' + fmt(cur.init) + '</div>' +
            (hasRec ? '<div class="cq-l num">más ' + fmt(recG) + ' al mes de OPEX durante ' + n + ' meses</div><div class="cq-tot" style="margin-top:8px"><div class="cq-l">Costo total a ' + n + ' meses</div><div class="cq-r cq-v num" style="font-size:20px">' + fmt(cur.total) + '</div></div>' : '<div class="cq-l">IVA incluido</div>');
        } else {
          sum = '<div class="cq-l">Leasing a ' + n + ' meses: cuota mensual</div><div class="cq-v num">' + fmt(cur.month) + ' al mes</div><div class="cq-l num">' + fmt(sc.leasing.cuota) + ' de leasing' + (hasRec ? ' + ' + fmt(recG) + ' de OPEX' : '') + ', IVA incluido</div>' +
            '<div class="cq-tot" style="margin-top:8px"><div class="cq-l">Costo total a ' + n + ' meses</div><div class="cq-r cq-v num" style="font-size:20px">' + fmt(cur.total) + '</div></div>';
        }
        el.innerHTML = head +
          q.notes.map(function (x) { return x.k === 'warn' ? '<div class="cq-alert" style="margin-bottom:8px">' + esc(x.t) + '</div>' : '<div class="cq-info" style="margin:0 0 8px">' + esc(x.t) + '</div>'; }).join('') +
          '<div class="cq-scroll"><table class="cq-q"><thead><tr><th>Detalle (valores netos)</th><th>Cant.</th><th>Unitario</th><th>Total</th></tr></thead><tbody>' + rows +
            (q.R.length ? '<tr class="cq-grp"><td colspan="4">OPEX mensual</td></tr>' + q.R.map(line).join('') : '') +
          '</tbody></table></div>' +
          '<div class="cq-perf"></div>' +
          '<div class="cq-tot num">' +
            '<div>Inversión inicial neta</div><div class="cq-r">' + fmt(q.initNet) + '</div>' +
            '<div>IVA 19%</div><div class="cq-r">' + fmt(ivaI) + '</div>' +
            '<div><b>Inversión inicial total</b></div><div class="cq-r"><b>' + fmt(q.initNet + ivaI) + '</b></div>' +
            (hasRec ? '<div style="padding-top:8px">OPEX mensual neto</div><div class="cq-r" style="padding-top:8px">' + fmt(q.recNet) + '</div><div>IVA 19%</div><div class="cq-r">' + fmt(ivaR) + '</div><div><b>OPEX mensual total</b></div><div class="cq-r"><b>' + fmt(recG) + '</b></div>' : '') +
          '</div>' +
          '<div class="cq-sumbox">' + sum + '</div>' +
          (showTerm ? '<table class="cq-cmp num"><thead><tr><th>A ' + n + ' meses, IVA incl.</th><th>Mensual</th><th>Total</th></tr></thead><tbody>' +
            '<tr class="' + (best === 'compra' ? 'is-best' : '') + '"><td>Compra</td><td>' + (hasRec ? fmt(sc.compra.month) + ' + ' : '') + fmt(sc.compra.init) + ' inicial</td><td>' + fmt(sc.compra.total) + '</td></tr>' +
            '<tr class="' + (best === 'leasing' ? 'is-best' : '') + '"><td>Leasing</td><td>' + fmt(sc.leasing.month) + '</td><td>' + fmt(sc.leasing.total) + '</td></tr>' +
            '</tbody></table>' : '') +
          '<div class="cq-cta">' +
            (formularioB2b() ? '<button class="cq-btn cq-btn--main" type="button" data-cot-act="solicitar">Solicitar esta cotización</button>' : '') +
            '<button class="cq-btn" type="button" data-cot-act="imprimir">Imprimir o guardar PDF</button>' +
            '<button class="cq-btn cq-btn--ghost" type="button" data-cot-act="copiar">Copiar resumen</button>' +
          '</div>' +
          '<p class="cq-fine">Valores en pesos chilenos. ' + (leas ? 'Cuotas de leasing referenciales, sin valor residual, con IVA sobre la cuota. ' : '') + 'Cotización referencial: disponibilidad de modelos y colores sujeta a stock al ' + dateStr + '. Los vehículos de catálogo tienen garantía de 1 año en motor y batería y 6 meses en los demás componentes.</p>';
        $('mTotal').textContent = fmt(cur.total);
        resumen = ['Cotización ' + quoteNo + ' · ' + dateStr, 'Empresa: ' + (client || '—') + (contact ? ' · ' + contact : ''), 'Solución: ' + (S.mode === 'b2b2c' ? 'Vehículo individual' : 'Flota compartida'), '']
          .concat(q.L.map(function (l) { return l.qty + ' x ' + l.label + ': ' + fmt(l.qty * l.unit) + ' neto'; }))
          .concat(q.R.length ? [''].concat(q.R.map(function (l) { return l.qty + ' x ' + l.label + ': ' + fmt(l.qty * l.unit) + ' neto al mes'; })) : [])
          .concat(['', 'Inversión inicial: ' + fmt(q.initNet + ivaI) + ' (IVA incl.)'])
          .concat(hasRec ? ['OPEX mensual: ' + fmt(recG) + ' (IVA incl.)'] : [])
          .concat([!leas ? 'Compra: ' + fmt(cur.init) + ' de pago inicial' + (hasRec ? ' + ' + fmt(recG) + '/mes de OPEX x ' + n : '') : 'Leasing ' + n + ' meses: ' + fmt(cur.month) + '/mes'])
          .concat(showTerm ? ['Costo total a ' + n + ' meses: ' + fmt(cur.total)] : [])
          .join('\n');
      }

      /* ---------- Acciones del ticket ---------- */
      function formularioB2b() { return document.querySelector('form[id^="B2bForm-"]'); }
      function solicitar() {
        var form = formularioB2b();
        if (!form) return;
        var put = function (name, value, soloSiVacio) {
          var f = form.querySelector('[name="' + name + '"]');
          if (!f || !value) return;
          if (soloSiVacio && f.value.trim()) return;
          f.value = value;
          f.dispatchEvent(new Event('input', { bubbles: true }));
        };
        var contacto = $('fContact').value.trim();
        put('contact[name]', contacto.split(/[,·(-]/)[0].trim(), true);
        put('contact[Empresa]', $('fClient').value.trim(), true);
        put('contact[body]', 'Hola, quiero avanzar con esta cotización armada en el cotizador de la página:\n\n' + resumen);
        var interes = form.querySelector('select[name="contact[Interes]"]');
        if (interes && interes.querySelector('option[value="fleet"]')) { interes.value = 'fleet'; interes.dispatchEvent(new Event('change', { bubbles: true })); }
        var ref = form.querySelector('input[name="contact[Cotizacion]"]');
        if (!ref) { ref = document.createElement('input'); ref.type = 'hidden'; ref.name = 'contact[Cotizacion]'; form.appendChild(ref); }
        ref.value = quoteNo;
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var campos = ['contact[name]', 'contact[Empresa]', 'contact[email]'].map(function (n) { return form.querySelector('[name="' + n + '"]'); });
        var foco = campos.find(function (f) { return f && !f.value.trim(); }) || form.querySelector('[type="submit"]');
        if (foco) setTimeout(function () { foco.focus({ preventScroll: true }); }, 600);
      }
      function imprimir() {
        var html = document.documentElement;
        html.classList.add('em-cot-print');
        var fin = function () { html.classList.remove('em-cot-print'); window.removeEventListener('afterprint', fin); };
        window.addEventListener('afterprint', fin);
        window.print();
        setTimeout(fin, 1000);
      }
      function copiar(btn) {
        var done = function () { btn.textContent = 'Copiado'; setTimeout(function () { btn.textContent = 'Copiar resumen'; }, 1600); };
        var fallback = function () {
          var t = document.createElement('textarea'); t.value = resumen; t.style.position = 'fixed'; t.style.opacity = '0';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          t.remove();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(resumen).then(done).catch(fallback);
        else fallback();
      }

      /* ---------- Eventos ---------- */
      function setQty(id, v) { S.qty[id] = Math.max(0, Math.min(2000, parseInt(v, 10) || 0)); }
      function getQty(id) { return S.qty[id] || 0; }
      function refresh() { renderFleet(); renderExtras(); renderTicket(); numberSteps(); }
      function focusAgain(sel) { var el = root.querySelector(sel); if (el) el.focus(); }

      root.addEventListener('click', function (e) {
        var act = e.target.closest('[data-cot-act]');
        if (act) {
          if (act.dataset.cotAct === 'solicitar') solicitar();
          else if (act.dataset.cotAct === 'imprimir') imprimir();
          else if (act.dataset.cotAct === 'copiar') copiar(act);
          return;
        }
        var b = e.target.closest('button[data-act]');
        if (!b) return;
        var id = b.dataset.id;
        setQty(id, getQty(id) + (b.dataset.act === 'inc' ? 1 : -1));
        refresh();
        focusAgain('button[data-act="' + b.dataset.act + '"][data-id="' + id + '"]');
      });
      root.addEventListener('change', function (e) {
        var t = e.target, opt = t.dataset.opt;
        if (t.matches('input[data-act=set]')) { setQty(t.dataset.id, t.value); refresh(); return; }
        if (t.name === N('mode')) { S.mode = t.value; refresh(); }
        else if (t.name === N('pay')) { S.pay = t.value; renderTicket(); }
        else if (t.name === N('term')) { S.term = parseInt(t.value, 10); renderTicket(); }
        else if (t.name === N('type')) { S.type = t.value; S.buckets.clear(); S.powers.clear(); renderFleet(); }
        else if (t.name === N('bucket')) { t.checked ? S.buckets.add(t.value) : S.buckets.delete(t.value); renderFleet(); }
        else if (t.name === N('power')) { var v = parseInt(t.value, 10); t.checked ? S.powers.add(v) : S.powers.delete(v); renderFleet(); }
        else if (opt === 'cabBat') { S.cabBat = parseInt(t.value, 10); renderTicket(); }
        else if (opt === 'cab') { S.cab = t.checked; refresh(); focusAgain('[data-opt="cab"]'); }
        else if (opt) { S[opt] = t.checked; renderTicket(); }
      });
      [$('fClient'), $('fContact')].forEach(function (f) { f.addEventListener('input', renderTicket); });
      if (!CFG.flota) S.mode = 'b2b2c';
      refresh();

      var aside = root.querySelector('.em-cot__aside');
      function ajustarAside() {
        aside.style.top = '';
        if (getComputedStyle(aside).position !== 'sticky') return;
        var arriba = parseFloat(getComputedStyle(aside).top) || 0;
        aside.style.top = Math.min(arriba, window.innerHeight - aside.offsetHeight - 16) + 'px';
      }
      if (window.ResizeObserver) new ResizeObserver(ajustarAside).observe($('ticket'));
      window.addEventListener('resize', ajustarAside);
      ajustarAside();
    }

    function start() { document.querySelectorAll('[data-em-cot]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-solutions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-b2b-interest]');
    if (!link) return;
    const section = link.closest('.em-business');
    const select = section?.querySelector('select[name="contact[Interes]"]');
    if (!select) return;
    select.value = link.dataset.b2bInterest;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-calculadora"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mismas referencias que sections/calculadora-scooter.liquid (arriendo a septiembre de 2026).
    var SERVICIOS = [
      { desbloqueo: 0, porMinuto: 135 }, // JET con membresía: desbloqueo gratis
      { desbloqueo: 0, porMinuto: 180 }, // Whoosh
      { desbloqueo: 500, porMinuto: 175 }, // Lime
    ];
    var CUOTA_JET = 2499;
    var VELOCIDAD_ARRIENDO = 16;
    var CARGA_POR_KM = 2;
    var AUTO_POR_KM = 1500 / 10;
    var MARGEN_USO = 0.6;
    var DIAS = 5;
    var SEMANAS_MES = 52 / 12;
    var plata = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
    var meses = function (m) {
      if (m < 1) { var s = Math.max(1, Math.round(m * 4.33)); return s + (s === 1 ? ' semana' : ' semanas'); }
      var r = Math.round(m * 10) / 10;
      return r.toString().replace('.', ',') + (r === 1 ? ' mes' : ' meses');
    };
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Anima un número desde el valor que muestra hasta el nuevo.
    function contar(el, hasta, formato) {
      var desde = Number(el.dataset.v || 0);
      el.dataset.v = hasta;
      if (quieto || desde === hasta) { el.textContent = formato(hasta); return; }
      var t0 = null;
      cancelAnimationFrame(el._raf);
      function paso(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 700);
        el.textContent = formato(desde + (hasta - desde) * (1 - Math.pow(1 - k, 3)));
        if (k < 1) el._raf = requestAnimationFrame(paso);
      }
      el._raf = requestAnimationFrame(paso);
    }

    function iniciar(raiz) {
      if (raiz.dataset.listo) return;
      raiz.dataset.listo = '1';
      var modelos;
      try { modelos = JSON.parse(raiz.querySelector('[data-modelos]').textContent); } catch (e) { modelos = {}; }
      var km = raiz.querySelector('[data-in="km"]');
      var out = function (k, ctx) { return (ctx || raiz).querySelector('[data-out="' + k + '"]'); };
      var vs = 'arriendo';
      var visible = false;

      // Nivel 2: hace ida y vuelta sin cargar. Nivel 1: hace un tramo, cargando en el destino.
      // Nivel 0: ni un tramo con margen (se calcula igual, con el de mayor autonomía).
      function elegir(lista, tramo) {
        if (!lista || !lista.length) return null;
        var util = function (m) { return m.range * MARGEN_USO; };
        for (var n = 2; n >= 1; n--) {
          for (var i = 0; i < lista.length; i++) if (util(lista[i]) >= tramo * n) return { m: lista[i], nivel: n };
        }
        return { m: lista.reduce(function (a, b) { return b.range > a.range ? b : a; }), nivel: 0 };
      }
      var COBERTURA = ['autonomía justa para este tramo', 'cargando en el destino', 'ida y vuelta sin cargar'];

      function calcular() {
        var tramo = Number(km.value);
        var diarios = tramo * 2;
        var minutos = (tramo / VELOCIDAD_ARRIENDO) * 60;
        var porTramo = SERVICIOS.reduce(function (t, s) { return t + s.desbloqueo + s.porMinuto * minutos; }, 0) / SERVICIOS.length;
        var tramosMes = DIAS * 2 * SEMANAS_MES;
        var kmMes = tramo * tramosMes;
        var gasto = vs === 'arriendo' ? porTramo * tramosMes + CUOTA_JET / 3 : kmMes * AUTO_POR_KM;
        var ahorroMes = gasto - kmMes * CARGA_POR_KM;

        out('km').textContent = tramo + ' km';
        out('hint').textContent = 'Ida y vuelta, ' + DIAS + ' días a la semana: ' + Math.round(diarios * DIAS) + ' km por semana.';
        contar(out('ahorro'), Math.max(0, ahorroMes), plata);

        var carril = {};
        ['scooter', 'bici'].forEach(function (tipo) {
          var lane = raiz.querySelector('[data-lane="' + tipo + '"]');
          var r = elegir(modelos[tipo], tramo);
          if (!r) { lane.hidden = true; return; }
          var payback = ahorroMes > 0 ? r.m.price / ahorroMes : Infinity;
          carril[tipo] = { lane: lane, r: r, payback: payback, anio: ahorroMes * 12 - r.m.price };
          var link = out('link', lane);
          link.href = r.m.url;
          var img = out('img', lane);
          if (r.m.img && img.getAttribute('src') !== r.m.img) img.src = r.m.img;
          img.alt = r.m.name;
          out('name', lane).textContent = r.m.name;
          out('price', lane).textContent = plata(r.m.price) + ' · hasta ' + r.m.range + ' km · ' + COBERTURA[r.nivel];
        });

        var tipos = Object.keys(carril);
        var finitos = tipos.map(function (t) { return carril[t].payback; }).filter(isFinite);
        var escala = Math.min(36, Math.max(6, Math.ceil(Math.max.apply(null, finitos.concat([1])) / 6) * 6));
        out('mid').textContent = escala / 2 + ' meses';
        out('max').textContent = escala + ' meses';

        var ganador = tipos.slice().sort(function (a, b) { return carril[b].r.nivel - carril[a].r.nivel || carril[a].payback - carril[b].payback; })[0] || null;
        tipos.forEach(function (t) {
          var c = carril[t], track = c.lane.querySelector('.em-race__track');
          var p = isFinite(c.payback) ? Math.min(1, c.payback / escala) : 1;
          c.lane.classList.toggle('is-win', t === ganador);
          out('payback', c.lane).textContent = isFinite(c.payback) ? meses(c.payback) : 'no se paga';
          contar(out('anio', c.lane), c.anio, function (n) { return (n >= 0 ? '+' : '−') + plata(Math.abs(n)); });
          track.classList.toggle('is-over', p >= 1);
          if (!visible) return;
          track.style.setProperty('--p', p);
          if (!quieto) {
            track.classList.add('is-moving');
            clearTimeout(track._t);
            track._t = setTimeout(function () { track.classList.remove('is-moving'); }, 1300);
          }
        });

        var nombre = { scooter: 'el scooter', bici: 'la bicicleta' };
        var otro = { scooter: 'bici', bici: 'scooter' };
        var v = out('veredicto');
        var g = ganador && carril[ganador], o = ganador && carril[otro[ganador]];
        if (!g) v.innerHTML = '';
        else if (g.r.nivel === 0) v.innerHTML = 'Para tramos de ' + tramo + ' km, revisa en la calculadora los modelos de mayor autonomía.';
        else if (!o || o.r.nivel < g.r.nivel) {
          v.innerHTML = 'Con ' + tramo + ' km por tramo te conviene <b>' + nombre[ganador] + '</b>: se paga en ' + meses(g.payback) + (g.r.nivel === 2 ? ' y hace ida y vuelta sin cargar.' : ', cargando en el destino.') +
            (o && o.r.nivel === 1 ? ' ' + nombre[otro[ganador]].charAt(0).toUpperCase() + nombre[otro[ganador]].slice(1) + ' también sirve si cargas en el destino.' : '');
        } else {
          var veces = o.payback / g.payback;
          v.innerHTML = 'Con ' + tramo + ' km por tramo, <b>' + nombre[ganador] + '</b> se paga ' + (veces >= 1.15 ? (Math.round(veces * 10) / 10).toString().replace('.', ',') + ' veces más rápido' : 'casi igual de rápido') + ' que ' + nombre[otro[ganador]] + (g.r.nivel === 1 ? ', cargando en el destino.' : '.');
        }

        var tipoUrl = ganador || 'scooter';
        var url = raiz.dataset.destino + (raiz.dataset.destino.indexOf('?') > -1 ? '&' : '?') + 'tipo=' + tipoUrl + '&km=' + tramo;
        raiz.querySelectorAll('[data-calc-banner-link]').forEach(function (a) { a.href = url; });
      }

      km.addEventListener('input', calcular);
      raiz.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        vs = e.target.value;
        calcular();
      });
      calcular();

      // La carrera arranca cuando el banner entra en pantalla.
      var arrancar = function () { if (visible) return; visible = true; calcular(); };
      if (quieto || !('IntersectionObserver' in window)) arrancar();
      else {
        var io = new IntersectionObserver(function (es) {
          if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); setTimeout(arrancar, 250); }
        }, { threshold: 0.35 });
        io.observe(raiz.querySelector('.em-race__panel'));
      }
    }

    function todas() { document.querySelectorAll('[data-calc-banner]').forEach(iniciar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
    else todas();
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculadora-scooter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SERVICIOS = [
      { id: 'jet', nombre: 'JET', desbloqueo: 400, porMinuto: 135, cuota: 2499, conPlan: true },
      { id: 'whoosh', nombre: 'Whoosh', desbloqueo: 0, porMinuto: 180, cuota: 0, conPlan: false },
      { id: 'lime', nombre: 'Lime', desbloqueo: 500, porMinuto: 175, cuota: 0, conPlan: false },
      { id: 'avg', nombre: 'Promedio', desbloqueo: null, porMinuto: null, cuota: 2499, conPlan: true },
    ];
    var MARGEN_USO = 0.6;
    var VELOCIDAD_ARRIENDO = 16;
    var CARGA_POR_KM = 2;
    var SEMANAS = 52;
    var NS = 'http://www.w3.org/2000/svg';
    var TIPOS = {
      scooter: {
        boton: 'Scooter eléctrico',
        tipoHint: 'Livianos y plegables: ideales para trayectos cortos y medianos en la ciudad, y para combinar con metro o bus.',
        sufijoAutonomia: '',
        recoTitulo: 'Scooter recomendado para tu trayecto',
        listaTitulo: 'Todos nuestros scooters NIU',
        listaHint: '✓ = alcanza tu recorrido diario con margen. Elige el que quieras comparar como «tu scooter propio».',
        propioTitulo: 'Tu scooter propio',
        cargaTexto: 'Cargar tu scooter cuesta',
        cargaHint: 'Calculado con el consumo real de la batería NIU (unos 10 Wh por km, incluidas las pérdidas de carga) y la tarifa eléctrica residencial promedio de la Región Metropolitana (unos $150 por kWh).',
        leyendaPropio: 'Tu scooter',
        arriendoNota: '',
        ver: 'Ver el ',
        cta: 'Tu scooter para este trayecto',
        propio: 'tu scooter propio',
        pagaSolo: ' se paga solo en ',
      },
      bici: {
        boton: 'Bicicleta eléctrica',
        tipoHint: 'Pedaleo asistido y más autonomía: ideales para trayectos largos o con subidas.',
        sufijoAutonomia: ' asistida',
        recoTitulo: 'Bicicleta recomendada para tu trayecto',
        listaTitulo: 'Todas nuestras bicicletas ADO',
        listaHint: '✓ = alcanza tu recorrido diario con margen, usando la asistencia al pedaleo. Elige la que quieras comparar como «tu bicicleta propia».',
        propioTitulo: 'Tu bicicleta propia',
        cargaTexto: 'Cargar tu bicicleta cuesta',
        cargaHint: 'Calculado con el consumo de una bicicleta eléctrica con asistencia al pedaleo (unos 12 Wh por km, incluidas las pérdidas de carga) y la tarifa eléctrica residencial promedio de la Región Metropolitana (unos $150 por kWh).',
        leyendaPropio: 'Tu bicicleta',
        arriendoNota: 'Como referencia usamos el arriendo de scooters compartidos, la alternativa de micromovilidad por minutos más usada en Santiago.',
        ver: 'Ver la ',
        cta: 'Tu bicicleta para este trayecto',
        propio: 'tu bicicleta propia',
        pagaSolo: ' se paga sola en ',
      },
    };

    function plata(n) {
      return '$' + Math.round(n).toLocaleString('es-CL');
    }
    function kilos(n) {
      return (Math.round(n * 10) / 10).toLocaleString('es-CL') + ' kg';
    }

    function iniciar(raiz) {
      if (raiz.dataset.listo) return;
      raiz.dataset.listo = '1';

      var conjuntos = {};
      raiz.querySelectorAll('[data-modelos]').forEach(function (el) {
        try {
          conjuntos[el.dataset.modelos] = JSON.parse(el.textContent);
        } catch (e) {
          conjuntos[el.dataset.modelos] = [];
        }
      });
      var disponibles = Object.keys(TIPOS).filter(function (t) {
        return conjuntos[t] && conjuntos[t].length;
      });
      if (!disponibles.length) return;
      var pedido = new URLSearchParams(window.location.search).get('tipo');
      var tipo = disponibles.indexOf(pedido) > -1 ? pedido : disponibles[0];
      var modelos = conjuntos[tipo];

      var q = function (k) {
        return raiz.querySelector('[data-out="' + k + '"]');
      };
      var entrada = function (k) {
        return raiz.querySelector('[data-in="' + k + '"]');
      };

      var st = {
        tramoKm: 5,
        dias: 5,
        membresia: true,
        servicio: 'avg',
        precio: modelos[0].price,
        precioManual: false,
        elegido: null,
        rendimiento: 10,
        litro: 1500,
      };
      // ?km= llega desde el banner de la portada (sections/banner-calculadora.liquid).
      var kmPedido = parseInt(new URLSearchParams(window.location.search).get('km'), 10);
      if (kmPedido >= 1 && kmPedido <= 30) {
        st.tramoKm = kmPedido;
        entrada('tramoKm').value = kmPedido;
        q('tramoKm').textContent = kmPedido + ' km';
      }

      function servicio(id) {
        for (var i = 0; i < SERVICIOS.length; i++) if (SERVICIOS[i].id === id) return SERVICIOS[i];
        return SERVICIOS[0];
      }
      function costoTramo(s, minutos) {
        var desbloqueo = st.membresia && s.id === 'jet' ? 0 : s.desbloqueo;
        return desbloqueo + s.porMinuto * minutos;
      }
      function costoTramoActual(minutos) {
        if (st.servicio !== 'avg') return costoTramo(servicio(st.servicio), minutos);
        var reales = SERVICIOS.filter(function (s) {
          return s.id !== 'avg';
        });
        return (
          reales.reduce(function (t, s) {
            return t + costoTramo(s, minutos);
          }, 0) / reales.length
        );
      }
      function cuotaSemanal() {
        if (!st.membresia) return 0;
        if (st.servicio === 'jet') return SERVICIOS[0].cuota / 4.33;
        if (st.servicio === 'avg') return SERVICIOS[0].cuota / 3 / 4.33;
        return 0;
      }

      function kmDiarios() {
        return st.tramoKm * 2;
      }
      function alcanza(m) {
        return m.range * MARGEN_USO >= kmDiarios();
      }
      function recomendado() {
        for (var i = 0; i < modelos.length; i++) if (alcanza(modelos[i])) return { m: modelos[i], excede: false };
        var mayor = modelos.reduce(function (a, b) {
          return b.range > a.range ? b : a;
        });
        return { m: mayor, excede: true };
      }
      function vigente() {
        return st.elegido !== null ? modelos[st.elegido] : recomendado().m;
      }

      function pintarTextos() {
        var t = TIPOS[tipo];
        raiz.querySelectorAll('[data-txt]').forEach(function (el) {
          var v = t[el.dataset.txt];
          el.textContent = v || '';
          el.hidden = !v;
        });
      }

      function pintarTipos() {
        var cont = q('tipos');
        cont.innerHTML = '';
        cont.hidden = disponibles.length < 2;
        disponibles.forEach(function (t) {
          cont.appendChild(
            boton(TIPOS[t].boton + '<small>' + conjuntos[t].length + (conjuntos[t].length === 1 ? ' modelo' : ' modelos') + ' · desde ' + plata(conjuntos[t][0].price) + '</small>', t === tipo, function () {
              if (t === tipo) return;
              tipo = t;
              modelos = conjuntos[t];
              st.elegido = null;
              st.precioManual = false;
              pintarTipos();
              pintarTextos();
              pintarReco();
              pintarModelos();
              calcular();
            })
          );
        });
      }

      function autonomiaTexto(m) {
        return m.range + ' km' + TIPOS[tipo].sufijoAutonomia;
      }
      function specs(m) {
        var out = ['hasta ' + autonomiaTexto(m), m.speed + ' km/h'];
        if (m.rangeElectric) out.push(m.rangeElectric + ' km solo motor');
        if (m.weight) out.push(kilos(m.weight));
        if (m.foldable) out.push('plegable');
        return out;
      }

      function pintarReco() {
        var r = recomendado();
        var m = vigente();
        var propio = st.elegido !== null && modelos[st.elegido] !== r.m;
        q('reco').innerHTML =
          '<div class="calc-scooter__reco-eyebrow">' +
          (propio ? 'Tu selección' : 'Recomendado para ' + kmDiarios() + ' km diarios') +
          '</div>' +
          '<div class="calc-scooter__reco-nombre">' + m.name + '</div>' +
          '<div class="calc-scooter__reco-specs"><span>Autonomía <b>hasta ' + autonomiaTexto(m) + '</b></span>' +
          '<span>Velocidad <b>' + m.speed + ' km/h</b></span>' +
          (m.rangeElectric ? '<span>Solo motor <b>' + m.rangeElectric + ' km</b></span>' : '') +
          (m.weight ? '<span>Peso <b>' + kilos(m.weight) + '</b></span>' : '') +
          (m.foldable ? '<span><b>Plegable</b></span>' : '') +
          '</div>' +
          '<div class="calc-scooter__reco-precio">' + plata(m.price) + '</div>' +
          (!propio && r.excede
            ? '<div class="calc-scooter__reco-aviso">Tu recorrido diario supera el margen de uso real recomendado incluso para este modelo: considera cargarlo a media jornada.</div>'
            : '') +
          '<a class="calc-scooter__reco-link" href="' + m.url + '">' + TIPOS[tipo].ver + m.name + '</a>';
        if (!st.precioManual) {
          st.precio = r.m.price;
          entrada('precio').value = r.m.price;
        }
      }

      function pintarModelos() {
        var lista = q('modelos');
        var mejor = recomendado().m;
        lista.innerHTML = '';
        modelos.forEach(function (m, i) {
          var ok = alcanza(m);
          var activo = st.elegido !== null ? st.elegido === i : m === mejor;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'calc-scooter__modelo' + (ok ? ' calc-scooter__modelo--alcanza' : '');
          b.setAttribute('aria-pressed', activo ? 'true' : 'false');
          b.innerHTML =
            '<span class="calc-scooter__check">' + (ok ? '✓' : '–') + '</span>' +
            '<span class="calc-scooter__modelo-main"><span class="calc-scooter__modelo-nombre">' + m.name + '</span>' +
            '<span class="calc-scooter__modelo-spec">' + specs(m).join(' · ') + '</span>' +
            (activo ? '<span class="calc-scooter__badge">' + (st.elegido !== null ? 'seleccionado' : 'recomendado') + '</span>' : '') +
            '</span><span class="calc-scooter__modelo-precio">' + plata(m.price) + '</span>';
          b.addEventListener('click', function () {
            st.elegido = i;
            st.precio = m.price;
            st.precioManual = true;
            entrada('precio').value = m.price;
            pintarReco();
            pintarModelos();
            calcular();
          });
          lista.appendChild(b);
        });
      }

      function boton(texto, activo, alHacerClic) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'calc-scooter__boton';
        b.setAttribute('aria-pressed', activo ? 'true' : 'false');
        b.innerHTML = texto;
        b.addEventListener('click', alHacerClic);
        return b;
      }

      function pintarMembresia() {
        var cont = q('membresia');
        cont.innerHTML = '';
        [
          { v: true, t: 'Con membresía' },
          { v: false, t: 'Pago por uso' },
        ].forEach(function (o) {
          cont.appendChild(
            boton(o.t, st.membresia === o.v, function () {
              st.membresia = o.v;
              pintarMembresia();
              pintarServicios();
              calcular();
            })
          );
        });
      }

      function pintarServicios() {
        var cont = q('servicios');
        cont.innerHTML = '';
        SERVICIOS.forEach(function (s) {
          var tarifa;
          if (s.id === 'avg') {
            tarifa = 'promedio de las 3';
          } else {
            var desbloqueo = st.membresia && s.id === 'jet' ? 0 : s.desbloqueo;
            tarifa = (desbloqueo ? plata(desbloqueo) + ' + ' : '') + plata(s.porMinuto) + '/min';
          }
          var nota = '';
          if (st.membresia && s.conPlan) nota = 'con membresía';
          else if (st.membresia && s.id !== 'avg') nota = 'sin plan mensual';
          cont.appendChild(
            boton(
              s.nombre + '<small>' + tarifa + '</small>' + (nota ? '<em>' + nota + '</em>' : ''),
              s.id === st.servicio,
              function () {
                st.servicio = s.id;
                pintarServicios();
                calcular();
              }
            )
          );
        });
      }

      function nodo(tag, attrs) {
        var e = document.createElementNS(NS, tag);
        for (var k in attrs) e.setAttribute(k, attrs[k]);
        return e;
      }

      function grafico(arriendo, propio, auto, equilibrio) {
        var svg = q('grafico');
        while (svg.firstChild) svg.removeChild(svg.firstChild);
        var W = 680,
          H = 280,
          M = { top: 16, right: 16, bottom: 30, left: 64 };
        var ancho = W - M.left - M.right,
          alto = H - M.top - M.bottom;
        var max = Math.max.apply(null, arriendo.concat(propio).concat(auto));
        max = Math.ceil(max / 50000) * 50000 || 50000;
        var x = function (s) {
          return M.left + (s / SEMANAS) * ancho;
        };
        var y = function (v) {
          return M.top + alto - (v / max) * alto;
        };

        for (var i = 0; i <= 4; i++) {
          var v = (max / 4) * i;
          svg.appendChild(nodo('line', { x1: M.left, x2: W - M.right, y1: y(v), y2: y(v), class: 'grilla' }));
          var t = nodo('text', { x: M.left - 10, y: y(v) + 3, class: 'eje', 'text-anchor': 'end' });
          t.textContent = v >= 1000000 ? (v / 1000000).toFixed(1).replace('.', ',') + ' M' : Math.round(v / 1000) + ' mil';
          svg.appendChild(t);
        }
        [0, 13, 26, 39, 52].forEach(function (s) {
          var t = nodo('text', {
            x: x(s),
            y: H - 8,
            class: 'eje',
            'text-anchor': s === 0 ? 'start' : s === 52 ? 'end' : 'middle',
          });
          t.textContent = s === 0 ? 'hoy' : 'sem. ' + s;
          svg.appendChild(t);
        });

        function ruta(serie) {
          return serie
            .map(function (v, i) {
              return (i ? 'L' : 'M') + x(i) + ',' + y(v);
            })
            .join(' ');
        }
        [
          [auto, 'var(--cs-auto)'],
          [arriendo, 'var(--cs-rent)'],
          [propio, 'var(--cs-brand)'],
        ].forEach(function (par) {
          svg.appendChild(nodo('path', { d: ruta(par[0]), fill: 'none', stroke: par[1], 'stroke-width': 2.5, 'stroke-linejoin': 'round' }));
        });

        if (equilibrio !== null && equilibrio >= 0 && equilibrio <= SEMANAS) {
          var bx = x(equilibrio);
          svg.appendChild(nodo('line', { x1: bx, x2: bx, y1: M.top, y2: M.top + alto, class: 'equilibrio' }));
          var et = nodo('text', { x: Math.min(bx + 6, W - M.right - 110), y: M.top + 14, class: 'equilibrio-texto' });
          et.textContent = 'Equilibrio: sem. ' + Math.round(equilibrio);
          svg.appendChild(et);
        }
      }

      function calcular() {
        var minutos = (st.tramoKm / VELOCIDAD_ARRIENDO) * 60;
        var tramos = st.dias * 2;
        var porTramo = costoTramoActual(minutos);
        var arriendoSemana = porTramo * tramos + cuotaSemanal();
        var cargaSemana = CARGA_POR_KM * st.tramoKm * tramos;
        var autoSemana = (st.tramoKm / Math.max(1, st.rendimiento)) * st.litro * tramos;

        var arriendo = [],
          propio = [],
          auto = [];
        for (var s = 0; s <= SEMANAS; s++) {
          arriendo.push(arriendoSemana * s);
          propio.push(st.precio + cargaSemana * s);
          auto.push(autoSemana * s);
        }
        var autoKm = st.litro / Math.max(1, st.rendimiento);
        var veces = Math.floor(autoKm / CARGA_POR_KM / 5) * 5;
        raiz.querySelector('[data-txt="cargaHint"]').textContent =
          TIPOS[tipo].cargaHint +
          ' Con tu auto (' + st.rendimiento + ' km/L, bencina a ' + plata(st.litro) + ') cada km cuesta cerca de ' + plata(autoKm) +
          (veces >= 5 ? ': unas ' + veces + ' veces más.' : '.');
        var neto = arriendoSemana - cargaSemana;
        var equilibrio = neto > 0 ? st.precio / neto : null;
        grafico(arriendo, propio, auto, equilibrio);

        q('porTramo').textContent = plata(porTramo);
        q('mesArriendo').textContent = plata(arriendoSemana * 4.33);
        q('mesAuto').textContent = plata(autoSemana * 4.33);
        function mostrarAhorro(clave, monto) {
          var celda = q(clave);
          celda.textContent = (monto >= 0 ? '+' : '−') + plata(Math.abs(monto));
          celda.parentElement.classList.toggle('calc-scooter__stat--bien', monto >= 0);
          celda.parentElement.classList.toggle('calc-scooter__stat--mal', monto < 0);
        }
        var ahorroAuto = auto[SEMANAS] - propio[SEMANAS];
        mostrarAhorro('ahorroArriendo', arriendo[SEMANAS] - propio[SEMANAS]);

        var ver = q('veredicto');
        var icono = ver.querySelector('.calc-scooter__icono');
        var texto = q('veredictoTexto');
        if (equilibrio !== null && equilibrio <= SEMANAS) {
          ver.classList.remove('calc-scooter__veredicto--mal');
          icono.textContent = '✓';
          texto.innerHTML =
            'Con tu ritmo actual, ' + TIPOS[tipo].propio + TIPOS[tipo].pagaSolo + '<strong>' + Math.round(equilibrio) + ' semanas</strong> (' +
            (equilibrio / 4.33).toFixed(1).replace('.', ',') +
            ' meses) frente al arriendo. ' +
            (ahorroAuto > 0
              ? 'Y si hoy usas el auto, en un año te ahorras <strong>' + plata(ahorroAuto) + '</strong> solo en bencina, que hoy son ' + plata(autoSemana * 4.33) + ' al mes en este trayecto.'
              : 'Y si hoy usas el auto, solo en bencina gastas ' + plata(autoSemana * 4.33) + ' al mes en este trayecto, sin contar estacionamiento, TAG ni mantención.');
        } else if (neto <= 0) {
          ver.classList.add('calc-scooter__veredicto--mal');
          icono.textContent = '!';
          texto.textContent =
            'Con esta frecuencia, el arriendo no alcanza a superar el costo de carga de ' + TIPOS[tipo].propio + '. Sube los días por semana o la distancia para ver cuándo conviene comprar.';
        } else {
          ver.classList.add('calc-scooter__veredicto--mal');
          icono.textContent = '!';
          texto.textContent =
            'A este ritmo, el punto de equilibrio llega después de un año. Si tus viajes son ocasionales, arrendar puede seguir siendo lo más simple por ahora.';
        }
        pintarCta();
      }

      function pintarCta() {
        var m = vigente();
        q('cta').innerHTML =
          '<div class="calc-scooter__cta-texto">' +
          '<span class="calc-scooter__cta-eyebrow">' + TIPOS[tipo].cta + '</span>' +
          '<span class="calc-scooter__cta-nombre">' + m.name + '</span>' +
          '<span class="calc-scooter__cta-precio">' + plata(m.price) + '</span></div>' +
          '<div class="calc-scooter__cta-acciones">' +
          '<a class="calc-scooter__cta-boton" href="' + m.url + '">Comprar ahora</a>' +
          '<a class="calc-scooter__cta-boton calc-scooter__cta-boton--sec" href="/pages/test-drives">Agendar test drive</a>' +
          '</div>';
      }

      function textoTramos() {
        q('tramos').textContent = 'Son ' + st.dias * 2 + ' tramos por semana (ida y vuelta) de ' + st.tramoKm + ' km cada uno.';
      }

      entrada('tramoKm').addEventListener('input', function (e) {
        st.tramoKm = Number(e.target.value);
        q('tramoKm').textContent = st.tramoKm + ' km';
        pintarReco();
        pintarModelos();
        textoTramos();
        calcular();
      });
      entrada('dias').addEventListener('input', function (e) {
        st.dias = Number(e.target.value);
        q('dias').textContent = st.dias + (st.dias === 1 ? ' día' : ' días');
        textoTramos();
        calcular();
      });
      entrada('precio').addEventListener('input', function (e) {
        var v = Number(e.target.value);
        st.precio = isNaN(v) || v < 0 ? 0 : v;
        st.precioManual = true;
        st.elegido = null;
        pintarModelos();
        calcular();
      });
      entrada('rendimiento').addEventListener('input', function (e) {
        st.rendimiento = Number(e.target.value);
        q('rendimiento').textContent = st.rendimiento + ' km/L';
        calcular();
      });
      entrada('litro').addEventListener('input', function (e) {
        var v = Number(e.target.value);
        st.litro = isNaN(v) || v < 0 ? 0 : v;
        calcular();
      });

      pintarTipos();
      pintarTextos();
      pintarReco();
      pintarModelos();
      pintarMembresia();
      pintarServicios();
      textoTramos();
      calcular();
    }

    function todas() {
      document.querySelectorAll('[data-calc-scooter]').forEach(iniciar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
    else todas();
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["convenios-accesos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-access-request]');
    if (!link) return;
    const select = document.querySelector('select[name="contact[Interes]"]');
    if (!select) return;
    select.value = 'access';
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["convenios-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizar = (texto) => texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

    document.querySelectorAll('.em-conv').forEach((portal) => {
      const buscador = portal.querySelector('[data-conv-search]');
      const botones = portal.querySelectorAll('[data-conv-filter]');
      const items = portal.querySelectorAll('[data-conv-grid] > li');
      const vacio = portal.querySelector('[data-conv-empty]');
      let tipo = '';

      const filtrar = () => {
        const consulta = normalizar(buscador ? buscador.value : '');
        let visibles = 0;
        items.forEach((item) => {
          const calza = (!tipo || item.dataset.convType === tipo) && normalizar(item.dataset.convName).includes(consulta);
          item.hidden = !calza;
          if (calza) visibles += 1;
        });
        if (vacio) vacio.hidden = visibles > 0;
      };

      botones.forEach((boton) => {
        boton.addEventListener('click', () => {
          tipo = boton.dataset.convFilter;
          botones.forEach((otro) => otro.setAttribute('aria-pressed', String(otro === boton)));
          filtrar();
        });
      });

      if (buscador) {
        buscador.addEventListener('input', () => {
          // Quien busca por nombre quiere ver todo el directorio, no solo un tipo.
          if (tipo) botones[0].click();
          filtrar();
        });
        buscador.addEventListener('keydown', (evento) => {
          if (evento.key !== 'Enter') return;
          evento.preventDefault();
          portal.querySelector('.em-conv__directory').scrollIntoView({ behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-producto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const aparecer = () => {
      if (reducir || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
      const observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            if (!entrada.isIntersecting) return;
            entrada.target.classList.add('landing-visible');
            observador.unobserve(entrada.target);
          });
        },
        { threshold: 0.12 }
      );
      document.querySelectorAll('.landing [data-aparecer]').forEach((pieza) => {
        // lo que ya esta a la vista al cargar no se esconde, para que no parpadee
        if (pieza.getBoundingClientRect().top < window.innerHeight) return;
        pieza.classList.add('landing-anima');
        observador.observe(pieza);
      });
    };

    // los botones de compra bajan al bloque de compra de la ficha, donde se elige color y se paga
    document.addEventListener('click', (evento) => {
      const enlace = evento.target.closest('[data-landing-comprar]');
      if (!enlace) return;
      const compra = document.querySelector('[id^="MainProduct-"]');
      if (!compra) return;
      evento.preventDefault();
      const cabecera = document.querySelector('sticky-header, .header-wrapper');
      const alto = cabecera ? cabecera.getBoundingClientRect().height : 0;
      window.scrollTo({
        top: compra.getBoundingClientRect().top + window.scrollY - alto - 16,
        behavior: reducir ? 'auto' : 'smooth',
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', aparecer);
    } else {
      aparecer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const enEditor = () => window.Shopify && window.Shopify.designMode;

    const aparecer = () => {
      if (reducir || enEditor() || !('IntersectionObserver' in window)) return;
      const observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            if (!entrada.isIntersecting) return;
            entrada.target.classList.add('l3-visible');
            observador.unobserve(entrada.target);
          });
        },
        { threshold: 0.12 }
      );
      document.querySelectorAll('.l3 [data-aparecer]').forEach((pieza) => {
        if (pieza.getBoundingClientRect().top < window.innerHeight) return;
        pieza.classList.add('l3-anima');
        observador.observe(pieza);
      });
    };

    // la primera pregunta y el primer punto quedan elegidos de entrada
    const preparar = () => {
      document.querySelectorAll('.l3--preguntas .l3__datos').forEach((lista) => {
        const primera = lista.querySelector('.dato');
        if (primera && !lista.querySelector('.dato[data-abierta]')) primera.setAttribute('data-abierta', '');
      });
      document.querySelectorAll('.l3--puntos .l3__puntos-foto').forEach((foto) => {
        const primero = foto.querySelector('[data-punto]');
        if (primero) primero.setAttribute('aria-current', 'true');
      });
    };

    document.addEventListener('click', (evento) => {
      const punto = evento.target.closest('[data-punto]');
      if (punto) {
        const pieza = punto.closest('.l3--puntos');
        if (!pieza) return;
        pieza.querySelectorAll('[data-punto]').forEach((otro) => otro.removeAttribute('aria-current'));
        punto.setAttribute('aria-current', 'true');
        const titulo = pieza.querySelector('[data-punto-titulo]');
        const texto = pieza.querySelector('[data-punto-texto]');
        if (titulo) titulo.textContent = punto.dataset.titulo || '';
        if (texto) texto.innerHTML = punto.dataset.texto || '';
        return;
      }

      const pregunta = evento.target.closest('.l3--preguntas .dato__rotulo');
      if (!pregunta) return;
      const fila = pregunta.closest('.dato');
      const abierta = fila.hasAttribute('data-abierta');
      fila.closest('.l3__datos').querySelectorAll('.dato[data-abierta]').forEach((otra) => otra.removeAttribute('data-abierta'));
      if (!abierta) fila.setAttribute('data-abierta', '');
    });

    const arrancar = () => {
      if (reducir) {
        document.querySelectorAll('.l3__fondo--video video').forEach((video) => video.pause());
      }
      preparar();
      aparecer();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }

    document.addEventListener('shopify:section:load', arrancar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secciones-producto"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.secciones-producto').forEach((section) => {
    if (section.dataset.acordeonMejorado === 'true') return;

    section.dataset.acordeonMejorado = 'true';
    const filas = section.querySelectorAll('.seccion-producto__fila');

    filas.forEach((fila) => {
      fila.addEventListener('toggle', () => {
        if (!fila.open) return;

        filas.forEach((otraFila) => {
          if (otraFila !== fila && otraFila.open) otraFila.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
